export type FilterOptions = {
    priority?: number[];
    id_type?: number[];
    status?: number[];
    accounting?: number[];
    who_responsible?: string[];
    /** the day ('yyyy-MM-dd') the requests are due by: the browser asks for date_expected <= it */
    date_expected?: string;
    escalation?: string[];
    is_open?: string[];
};

export type AttachmentFile = {
    file?: File;
    url?: string;
    idz?: number;
    markdownImage?: {width: number, height: number};
}

/** A person the follower of a request can be picked from (rp-ms-helpdesk tickets/followers); sa = an SA user. */
export type Follower = {
    user_name: string;
    login_name: string;
    sa: boolean;
};

export type HelpdeskLists = {
    id_type?: {k: number, v: string}[];
    status?: {k: number, v: string}[];
    priority?: {k: number, v: string}[];
    accounting?: {k: number, v: string}[];
    who_responsible?: {k: number | string, v: string}[];
    who_follower?: {k: number | string, v: string}[];
};

/** The browser shows the open requests by default; TicketBrowserAdapter adds the companies of the current group. */
export const FILTER_DEFAULT_OPTIONS: FilterOptions = {
    is_open: ['1'],
};

export const REQUEST_TYPES = [
    {k: 1, v: 'Error'},
    {k: 2, v: 'Paid action'},
    {k: 3, v: 'RFC'},
]

export const REQUEST_STATUSES = [
    {k: 1, v: 'Suggestion'},
    {k: 2, v: 'In progress'},
    {k: 3, v: 'Resolved'},
    {k: 4, v: 'Customer pending'},
    {k: 5, v: 'Rejected'},
    {k: 6, v: 'Closed'},
]

export const REQUEST_PRIORITIES = [
    {k: 1, v: 'Low'},
    {k: 2, v: 'Significant'},
    {k: 3, v: 'Critical'},
]

export const FILE_TYPES = new Map<string, string>([
    ['jpg', 'image/jpeg'], 
	['jpeg', 'image/jpeg'], 
	['gif', 'image/gif'], 
	['png', 'image/png'], 
	['tiff', 'image/tiff'], 
	['bmp', 'image/bmp'], 
	['xls', 'application/vnd.ms-excel'], 
	['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'], 
	['doc', 'application/msword'], 
	['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'], 
	['zip', 'application/zip'],
	['pdf', 'application/pdf'],
	['msg', 'application/vnd.ms-outlook']
]);
